import { Injectable } from '@angular/core';

/**
 * Configuration service for the Popover directive.
 * You can inject this service, typically in your root component, and customize
 * the values of its properties in order to provide default values for all the
 * popovers used in the application.
 */
@Injectable()
export class PopoverConfig {
  public placement: string = 'top';
  public triggers: string = 'click';
  public container: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./~/ng2-bootstrap/src/popover/popover-config.ts